import { DataTableFilterMeta } from "primereact/datatable";

export const isNationalOptions = [
  { value: true, label: "Krajowy (Polska)" },
  { value: false, label: "Międzynarodowy" },
];

export function getIsNationalFromUrl(
  searchParams: URLSearchParams,
): boolean | undefined {
  const value = searchParams.get("isNational");
  if (value === "true") return true;
  if (value === "false") return false;
  return undefined;
}

export function getIsNationalFilter(
  filters: DataTableFilterMeta,
): boolean | undefined {
  return filters.isNational && "value" in filters.isNational
    ? ((filters.isNational.value as boolean | undefined) ?? undefined)
    : undefined;
}
